import {
  Button,
  HeadingText,
  Image,
  ParagraphText,
  StackLayout,
} from '@leagueplatform/genesis-core';
import {
  useMasonryEngineActionEmitter,
  type MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import type {
  MasonryComposableCardNode,
  MasonryDriverAction,
} from '@leagueplatform/masonry-renderers';

type LinkClinicResultModalProps =
  MasonryEngineNodeRendererProps<MasonryComposableCardNode>;

type LinkClinicResultModalBody = NonNullable<
  LinkClinicResultModalProps['body']
> & {
  subheadingSecondary?: string;
};

export const LinkClinicResultModal = ({
  body: rawBody,
  cta,
  onFirstButtonClick,
  onSecondButtonClick,
  rootElementRef,
}: LinkClinicResultModalProps) => {
  const body = rawBody as LinkClinicResultModalBody | undefined;
  const invokeAction = useMasonryEngineActionEmitter<MasonryDriverAction>();
  const firstCtaLabel = cta?.firstCTA?.label;
  const secondCtaLabel = cta?.secondCTA?.label;

  return (
    <StackLayout
      ref={rootElementRef}
      orientation="vertical"
      horizontalAlignment="center"
      spacing="$oneAndHalf"
      css={{
        textAlign: 'center',
        paddingInline: '$one',
      }}
    >
      {body?.imageSrc ? (
        <Image
          src={body.imageSrc}
          alt={body.imageAltText ?? ''}
          css={{
            width: '176px',
            height: 'auto',
          }}
        />
      ) : null}

      <StackLayout
        orientation="vertical"
        horizontalAlignment="start"
        spacing="$half"
        css={{ textAlign: 'start' }}
      >
        {body?.heading ? (
          <HeadingText level="3" size="lg">
            {body.heading}
          </HeadingText>
        ) : null}

        {body?.subheading ? (
          <ParagraphText css={{}}>{body.subheading}</ParagraphText>
        ) : null}

        {body?.subheadingSecondary ? (
          <ParagraphText>{body.subheadingSecondary}</ParagraphText>
        ) : null}
      </StackLayout>

      {firstCtaLabel || secondCtaLabel ? (
        <StackLayout
          orientation="horizontal"
          horizontalAlignment="end"
          spacing="$one"
          css={{ width: '100%', marginBlockStart: '$one' }}
        >
          {secondCtaLabel ? (
            <Button
              priority="secondary"
              onClick={() => {
                if (onSecondButtonClick) invokeAction(onSecondButtonClick);
              }}
            >
              {secondCtaLabel}
            </Button>
          ) : null}

          {firstCtaLabel ? (
            <Button
              priority="primary"
              onClick={() => {
                if (onFirstButtonClick) invokeAction(onFirstButtonClick);
              }}
            >
              {firstCtaLabel}
            </Button>
          ) : null}
        </StackLayout>
      ) : null}
    </StackLayout>
  );
};
